module.exports = __webpack_public_path__ + "dde8ae48630224f7d69661fac2ebe336.png";